<template>
    <el-table stripe v-loading="loading" :data="tableData" height="calc(100% - 100px)" tooltip-effect="dark" style="width: 100%" :header-cell-style="headCellStyle">
        <el-table-column :label="$t('integration.status')" prop="status">
            <template #default="{row}">
                {{ $t(baseSituation[row.status].title) }}
            </template>
        </el-table-column>
        <el-table-column :label="$t('integration.detection_value')" prop="val"></el-table-column>
        <el-table-column :label="$t('integration.acquisition_time')" prop="collectTime">
            <template #default="{row}">
                {{ $timetransition(row.collectTime) }}
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { baseSituation } from '@/utils/convert';

export default {
    props: ['tableData', 'loading'],
    computed: {
        baseSituation: () => baseSituation
    }
};
</script>
